// extracted by mini-css-extract-plugin
export default {"root":"SsoForm_root__8-lf3","error":"SsoForm_error__mHQI9","input":"SsoForm_input__t9yRQ"};